import { useContext } from 'react';
import { LoadingContext } from '../context/LoadingContext';

function useLoading() {
  const { loading, addLoading, removeLoading } = useContext(LoadingContext);
  return { loading, addLoading, removeLoading };
}

export default useLoading;